import { render, staticRenderFns } from "./CGridItem.vue?vue&type=template&id=4ded6ae7"
import script from "./CGridItem.vue?vue&type=script&lang=js"
export * from "./CGridItem.vue?vue&type=script&lang=js"
import style0 from "./CGridItem.vue?vue&type=style&index=0&id=4ded6ae7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports